import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../../../components/Table/Table';
import './ServiceHistory.css';
//icons
import editIcon from '../../../../../assets/editIcon.png'
import editInactive from '../../../../../assets/tokens/editInactive.png'
import eyeOn from '../../../../../assets/tokens/eyeOn.png'
import eyeOff from '../../../../../assets/tokens/eyeOff.png'
//services
import { customer } from '../../../../../services/customer';  
//utils
import { formatDate, formatTime } from '../../../../../utils/utils';

const ServiceHistory = ({ id, type, supplier }) => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const columns = [
    { 
      header: 'Request Folio', 
      field: 'id' 
    },
    { 
      header: 'Category', 
      field: 'category' 
    },
    { 
      header: 'Subcategory', 
      field: 'subcategory' 
    },
    { 
      header: 'Supplier', 
      field: 'supplier' 
    },
    { 
      header: 'Type of Service', 
      field: 'typeOfService' 
    },
    { 
      header: 'Date', 
      field: 'date' 
    },
    { 
      header: 'Time', 
      field: 'time' 
    },
    { 
      header: 'Number of barter bucks used', 
      field: 'tokensUsed' 
    },
    { 
      header: 'Status', 
      field: 'status' 
    },
    {
      header: '',
      render: (row) => (
        <div className="action-buttons">
          <button className="edit-btn" onClick={() => handleEdit(row)}>
            <img src={eyeOn} alt="Edit" />
          </button>
        </div>
      ) 
    }
  ];

  const handleEdit = (row) => {
    navigate(`/customers/service-history/${row.id}`, {
      state: { service: row }
    });
  };

  const fetchServices = async (page = 1) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        items_per_page: 10
      };
      
      let response;
      if(type === 'received') {
        response = await customer.requestReceived(id, params);
      }else{
        response = await customer.serviceOffered(id, params);
      }
      if (response.status === 'success') {
        setTotalItems(response.data.total);
        const formattedServices = response.data.data.map(service => ({
          ...service,
          status: service.status,
          category: service.service.category.name,
          subcategory: service.service.subcategory.name,
          typeOfService: service.service.service_type,
          tokensUsed: service.service.service_cost,
          date: formatDate(service.service.created_at.split('T')[0]),
          time: formatTime(service.service.created_at),
          supplier: supplier
        }));
        setServices(formattedServices);
      }
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices(currentPage);
  }, [currentPage, id]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="request-history">
      <Table
        data={services}
        columns={columns}
        columnsShare={1}
        itemsPerPage={10}
        currentPage={currentPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        loading={loading}
      />
    </div>
  );
};

export default ServiceHistory;
